import * as Sentry from '@sentry/react';
import {
    all,
    call,
    put,
    select,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import {
    CHALLENGES_REQUESTED,
    CHALLENGE_UPDATE_REQUESTED,
    PARTICIPATED_CHALLENGES_REQUESTED,
} from './constants';
import { getChallengeToUpdate, getChallenges } from './selectors';
import {
    getPartnerChallenges,
    updateChallengeStatus,
    getParticipatedChallenges,
} from '../../api/';
import {
    challengesSucceeded,
    challengesFailed,
    challengeUpdateFailed,
    challengeUpdateSucceeded,
    participatedChallengesFailed,
    participatedChallengesSucceeded,
} from './actions';
import { getUserData } from '../auth/selectors';
import { parseClientError } from '../../api/utils';
import { logException } from '../../logger';

// gets called when `CHALLENGES_REQUESTED` is dispatched
function* getRequestedChallenges() {
    try {
        const challenges = yield call(getPartnerChallenges);
        yield put(challengesSucceeded(challenges));
    } catch (e) {
        Sentry.captureException(e);
        const userData = yield select(getUserData);
        logException(e, { ...userData });
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(challengesFailed(message));
    }
}

// gets called when `PARTICIPATED_CHALLENGES_REQUESTED` is dispatched
function* requestParticipatedChallenges() {
    try {
        const challenges = yield call(getParticipatedChallenges);
        yield put(participatedChallengesSucceeded(challenges));
    } catch (e) {
        Sentry.captureException(e);
        const userData = yield select(getUserData);
        logException(e, { ...userData });
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(participatedChallengesFailed(message));
    }
}

function* updateChallengeActiveStatus() {
    try {
        let challenges = yield select(getChallenges);
        const challengeToUpdateIndex = yield select(getChallengeToUpdate);
        const challengeToUpdate = challenges[challengeToUpdateIndex];
        let params = {};
        params = { active: !challengeToUpdate.isActive };
        const challenge = yield call(updateChallengeStatus, {
            params,
            challengeId: challengeToUpdate.id,
        });
        yield put(
            challengeUpdateSucceeded(challenge[0], challengeToUpdateIndex),
        );
    } catch (e) {
        Sentry.captureException(e);
        const userData = yield select(getUserData);
        logException(e, { ...userData });
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(challengeUpdateFailed(message));
    }
}

export default function*() {
    yield all([
        yield takeLatest(CHALLENGES_REQUESTED, getRequestedChallenges),
        yield takeLatest(
            PARTICIPATED_CHALLENGES_REQUESTED,
            requestParticipatedChallenges,
        ),
        yield takeEvery(
            CHALLENGE_UPDATE_REQUESTED,
            updateChallengeActiveStatus,
        ),
    ]);
}
